<template>
  <div id="staff-info">
    <el-form
      class="info-table"
      label-position="right"
      label-width="100px"
      :model="userInfo"
    >
      <el-form-item label="员工ID">
        <span>{{ userInfo.user_name }}</span>
      </el-form-item>
      <el-form-item label="姓名">
        <span>{{ userInfo.real_name }}</span>
      </el-form-item>
      <el-form-item label="外文名">
        <span>{{ userInfo.foreign_name }}</span>
      </el-form-item>
      <el-form-item label="手机号">
        <span>{{ userInfo.phone_num }}</span>
      </el-form-item>
      <el-form-item label="性别">
        <span>{{ userGender }}</span>
      </el-form-item>
      <el-form-item label="身份证号">
        <span>{{ userInfo.id_num }}</span>
      </el-form-item>
      <el-form-item label="状态">
        <span>{{ userStatus }}</span>
      </el-form-item>
      <template v-if="expand.length">
        <el-form-item
          class="edit-item"
          :label="item.key_desc"
          v-for="(item, index) in expand"
          :key="index"
        >
          <el-input
            v-model="item.info"
            :disabled="item.disabled"
          ></el-input>
          <div
            class="form-btn"
            v-if="item.ifExpandEdit"
          >
            <div v-if="!item.isEdit">
              <el-button
                size="medium"
                type="primary"
                @click="inputExpand(item)"
                :disabled="!item.ifExpandEdit"
              >
                编辑
              </el-button>
            </div>
            <div
              v-else
              :style="{ width: item.isEdit ? '150px' : '90px' }"
            >
              <el-button @click="cancelInput(item)">取消</el-button>
              <el-button
                type="success"
                size="medium"
                @click="updateExpand(item)"
              >保存</el-button>
            </div>
          </div>
        </el-form-item>
      </template>
    </el-form>
  </div>
</template>

<script>
import { staffUserInfo, staffExpandUpdate } from '@/api/staff'
export default {
  name: 'staff-info',
  components: {},
  data () {
    return {
      userInfo: {},
      expand: [],
      originInfo: '',
    }
  },
  created () {
    this.getUserInfo()
  },
  methods: {
    async getUserInfo () {
      const { result } = await staffUserInfo()
      this.userInfo = result.base
      this.expand = result.expand
      this.expand.forEach((item) => {
        item.ifExpandEdit = item.status === 1 ? true : false
        item.disabled = true
        item.isEdit = false
      })
    },
    inputExpand (item) {
      this.originInfo = item.info
      item.disabled = false
      item.isEdit = true
      this.expand = [...this.expand]
    },
    async updateExpand (item) {
      const { id, info } = item
      const { code, msg } = await staffExpandUpdate({ id, info })
      if (code === this.CONFIG.CODE_SUCCESS) {
        this.$message({
          type: 'success',
          message: msg,
        })
        item.disabled = true
        item.isEdit = false
        this.expand = [...this.expand]
      }
    },
    cancelInput (item) {
      item.info = this.originInfo
      item.isEdit = false
      item.disabled = true
      this.expand = [...this.expand]
    },
  },
  computed: {
    userGender () {
      return this.GENDER_STATUS[this.userInfo.gender]
    },
    userStatus () {
      return this.STAFF_STATUS[this.userInfo.status]
    },
  },
}
</script>

<style lang="less" scoped>
.info-table {
  margin: 50px 400px;
}
// /deep/.el-input.is-disabled .el-input__inner {
//   color: #606266;
//   cursor: default;
// }
.form-btn {
  padding-left: 10px;
  // display: inline-block;
}
</style>
<style>
.edit-item .el-form-item__content {
  display: flex;
}
</style>
